module.exports = __webpack_public_path__ + "img/insurance.f0492e2c.png";